import { Divider } from '@/components/base';

import useChartDetail from '../../hooks/use-chart-detail';
import { ChartDetailBody } from './components/body';
import { ChartDetailHeader } from './components/header';

type Props = {
  chart_alias?: string;
};

export function ChartDetailContainer(props: Props) {
  const chartInfo = useChartDetail({
    chart_alias: props.chart_alias,
  });

  return (
    <div className="flex flex-col h-screen w-full overflow-auto">
      <ChartDetailHeader chartInfo={chartInfo} />
      <Divider />
      <ChartDetailBody chartInfo={chartInfo} />
    </div>
  );
}
